module.exports = "<div class=\"buttons text-right\"> <button type=submit ng-disabled=!isValid(item) ng-click=\"save(item, null)\" class=\"btn btn-primary\" title=\"{{ 'jdro_common.save' | translate }}\"> <i class=\"fa fa-paper-plane-o\"></i> </button> <button type=button ng-click=cancel(item) class=\"btn btn-default\" title=\"{{ 'jdro_common.cancel' | translate }}\"> <i class=\"fa fa-eraser\"></i> </button> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-uaa/directives/layout/tableButtonGroupEdit.html
// module id = 379
// module chunks = 0